import { get } from 'lodash-es';

export const isHandledError = (error: any): boolean =>
  get(error, 'isHandled', false);

export const isUnhandledError = (error: any): boolean => !isHandledError(error);
